import { useQuery } from 'react-query'

import httpClient from 'services/http-client'

import { TEN_MINUTES_STALE_TIME } from 'constants/apis'

const GET_CURRENCY_RATE = '/graphql'

type rateData = {
  id: string
  rate: number
}
type CurrencyRate = {
  data: {
    currencyRate: rateData
  }
}

const useGetCurrencyRate = (from: string, to: string) => {
  const data = JSON.stringify({
    query: `query ($id: String!){
      currencyRate (id: $id) {
          id
          rate
      }
  }`,
    variables: { id: `${from}${to}` },
  })

  return useQuery({
    queryKey: [GET_CURRENCY_RATE, data],
    queryFn: async () => {
      const { data: currencyRates } = await httpClient.post<CurrencyRate>(GET_CURRENCY_RATE, data)
      return currencyRates.data.currencyRate
    },
    staleTime: TEN_MINUTES_STALE_TIME,
  })
}

export default useGetCurrencyRate
